__turbopack_context__.v({
  "fade-out": "styles-module-scss-module__IP19ja__fade-out",
  "fadeIn": "styles-module-scss-module__IP19ja__fadeIn",
  "fadeOut": "styles-module-scss-module__IP19ja__fadeOut",
  "item": "styles-module-scss-module__IP19ja__item",
  "item__button": "styles-module-scss-module__IP19ja__item__button",
  "item__condition": "styles-module-scss-module__IP19ja__item__condition",
  "item__conditionTitle": "styles-module-scss-module__IP19ja__item__conditionTitle",
  "item__conditionValue": "styles-module-scss-module__IP19ja__item__conditionValue",
  "item__location": "styles-module-scss-module__IP19ja__item__location",
  "item__price": "styles-module-scss-module__IP19ja__item__price",
  "item__priceOldValue": "styles-module-scss-module__IP19ja__item__priceOldValue",
  "item__pricePercent": "styles-module-scss-module__IP19ja__item__pricePercent",
  "item__priceValue": "styles-module-scss-module__IP19ja__item__priceValue",
  "markdown": "styles-module-scss-module__IP19ja__markdown",
  "markdown__header": "styles-module-scss-module__IP19ja__markdown__header",
  "markdown__images": "styles-module-scss-module__IP19ja__markdown__images",
  "markdown__imagesPreview": "styles-module-scss-module__IP19ja__markdown__imagesPreview",
  "markdown__imagesWrap": "styles-module-scss-module__IP19ja__markdown__imagesWrap",
  "markdown__link": "styles-module-scss-module__IP19ja__markdown__link",
  "markdown__list": "styles-module-scss-module__IP19ja__markdown__list",
  "markdown__list--open": "styles-module-scss-module__IP19ja__markdown__list--open",
  "markdown__openButton": "styles-module-scss-module__IP19ja__markdown__openButton",
  "markdown__openButtonIcon": "styles-module-scss-module__IP19ja__markdown__openButtonIcon",
  "markdown__openButtonMobile": "styles-module-scss-module__IP19ja__markdown__openButtonMobile",
  "markdown__openButtonMobileIcon": "styles-module-scss-module__IP19ja__markdown__openButtonMobileIcon",
  "markdown__price": "styles-module-scss-module__IP19ja__markdown__price",
  "markdown__priceValue": "styles-module-scss-module__IP19ja__markdown__priceValue",
  "markdown__priceWrap": "styles-module-scss-module__IP19ja__markdown__priceWrap",
  "markdown__quantity": "styles-module-scss-module__IP19ja__markdown__quantity",
  "markdown__title": "styles-module-scss-module__IP19ja__markdown__title",
  "pagination__active": "styles-module-scss-module__IP19ja__pagination__active",
  "pagination__disabled": "styles-module-scss-module__IP19ja__pagination__disabled",
});
